"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceAccessType = exports.ServiceConnectionConfigLocation = void 0;
var ServiceConnectionConfigLocation;
(function (ServiceConnectionConfigLocation) {
    /**
     * All config data, secrets and non-secrets both, are accessed from the local environment. (Eg, .env file or process.env)
     */
    ServiceConnectionConfigLocation["LocalEnv_All"] = "localEnv-all";
    /**
     * Use Wranggle's built-in mechanism, where the secret is encrypted separately for each agent/bot/client apiKey/apiSecret
     *  that is granted access. The cipher data is store by Wranggle, decrypted when apiKey/apiSecret is provided by the agent.
     * Each secret is encrypted using AES-192-CBC with a derived key (generated using HKDF method with strong random cipherIv)
     * Upsides: convenient and granular control over which services can access which secrets
     * Downsides: the plaintext is transmitted/relayed over multiple stops (and not held in cleared Buffers as of 2021);
     */
    ServiceConnectionConfigLocation["WranggleBuiltin_Auto"] = "auto-1.aes-192-cbc.hkdf";
    //
    // /**
    //  * Wranggle holds only cipher data and serves it to services with authenticated apiKeys granted access.
    //  * Upsides: Wranggle never sees the actual config secret
    //  * Downsides: each service using it needs lib/src to decrypt
    //  */
    // todo: WranggleBuiltin_CipherStore = 'cipher-store-1',
    // todo: others; perhaps integrate with popular secret stores (eg, hashicorp)
})(ServiceConnectionConfigLocation = exports.ServiceConnectionConfigLocation || (exports.ServiceConnectionConfigLocation = {}));
/**
 * How secret should be unpacked and/or applied when used to access the service.
 * Needs work.. currently it awkwardly tries to coerce the { secret, notSecretData } of the managed secrets data into the needed shape.
 */
var ServiceAccessType;
(function (ServiceAccessType) {
    /**
     * Expand config/secret and non-secret data as IORedis.Options for establishing a redis connection
     */
    ServiceAccessType["IORedis"] = "IORedis";
    /**
     * Generally for external service accessed over http. Config/secret supplied as a header.
     * Eg, if fetched secret is "123someSecret456" we know to use it as: { Authorization: 'Bearer 123someSecret456' }
     * Plus optional non-secret headers.
     */
    ServiceAccessType["BearerToken"] = "BearerToken";
    /**
     * Config/secret to be applied manually.
     */
    ServiceAccessType["Other"] = "Other";
    // perhaps Json, same as Other but json-parsed. Checking/guessing each time is awkward
})(ServiceAccessType = exports.ServiceAccessType || (exports.ServiceAccessType = {}));
//# sourceMappingURL=service-connection.js.map